<template>
  <div>
    <el-carousel :height="height" class="carousel" :interval="interval" arrow="never" trigger="click" indicator-position="none" ref="cardShow" @change="bannerChange">
        <div class="arrowContainer">
            <img class="carousel-Arrow" :src="arrowLeft" alt="" @click="arrowClick('left')">
            <img class="carousel-Arrow" :src="arrowRight" alt="" @click="arrowClick('right')">
        </div>
        <el-carousel-item v-for="(item,index) in topBanner" :key="index">
            <div class="carousel-item-img" :style="'background-image:url(' + item.src + ')'"></div>
        </el-carousel-item>
        <div class="indicator">
            <img v-for="(item,index) in topBanner.length" :src="index==activeIndex?indicatorActiveImg:indicatorDefaultImg" :key="index" @click="changeIndicator(index)" alt="">
        </div>
        <div class="slogn">{{slogn}}</div>
        <div class="subSlogn">{{subSlogn}}</div>
    </el-carousel>
  </div>
</template>

<script>
export default {
    name: 'carousel',
    props:{
        topBanner:{
            default: () => [],
            type: Array
        },
        slogn:{
            default: "",
            type: String
        },
        subSlogn:{
            default: "",
            type: String
        },
        height:{
            default: "200px",
            type: String
        },
        interval:{
            default: 5000,
            type: Number
        },
        arrowLeft:{
            default: require("@/assets/images/carousel-white-left.png"),
            type: String
        },
        arrowRight:{
            default: require("@/assets/images/carousel-white-right.png"),
            type: String
        },
        indicatorDefaultImg:{
            default: require("@/assets/images/dot-default.png"),
            type: String
        },
        indicatorActiveImg:{
            default: require("@/assets/images/dot-active.png"),
            type: String
        }
    },
    data () {
        return {
            activeIndex: 0,
        }
    },
    methods: {
        arrowClick(val) {
            if(val === 'right') {
                this.$refs.cardShow.next()
            } else {
                this.$refs.cardShow.prev()
            }
        },
        bannerChange(nowBannerIndex,prevBannerIndex){
            this.activeIndex = nowBannerIndex
        },
        changeIndicator(index){
            this.activeIndex = index
            this.$refs.cardShow.setActiveItem(index)
        }
    },
}
</script> 

<style lang='less' scoped>
.carousel{
    position: relative;
    .slogn{
        position: absolute;
        z-index: 99;
        top: 45%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: white;
        font-size: 90px;
        font-weight: bold;
        user-select: none;
    }
    .subSlogn{
        position: absolute;
        z-index: 99;
        top: 57%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: white;
        font-size: 35px;
        letter-spacing: 17px;
        user-select: none;
    }
    .carousel-item-img{
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 2;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }
    .arrowContainer{
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;
        display: flex;
        justify-content: space-between;
        padding: 0 40px;
        .carousel-Arrow{
            cursor: pointer;
        }
    }
    .indicator{
      position: relative;
      z-index: 3;
      top: 82%;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      img{
        margin: 0 10px;
        cursor: pointer;
      }
    }
  }
</style>
